<div class="allcp-form theme-primary mw800" style="margin-top:3%">
	<div class="panel panel-primary mw800"style="background:#fff">
        <div class="panel-body">
            <div class="col-md-4">
                <h3 class="text-center payment-success-icon" style="margin: 30px auto;border: 4px solid #E5EAEE;width:120px;height:120px;border-radius: 60px;background:#fff; ">
                    <i class="fa fa-check text-success m20" style="font-size:48px"></i>
                </h3>
            </div>
            <div class="col-md-8">
                <h3 class="text-success">Demo Talebiniz Bize Ulaşmıştır!</h3>
                <p class="fs16">Hesap bilgileriniz en kısa süre içerisinde e-posta adresinize gönderilecektir.</p>
            </div>
        </div>
	</div>
</div>

<!-- Google Code for Form Doldurma Conversion Page --> 
<script type="text/javascript"> /* <![CDATA[ */ var google_conversion_id = 866120042; var google_conversion_language = "en"; var google_conversion_format = "3"; var google_conversion_color = "ffffff"; var google_conversion_label = "0IUVCJ-e33EQ6uL_nAM"; var google_remarketing_only = false; /* ]]> */ </script> <script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"> </script> <noscript> <div style="display:inline;"> <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/866120042/?label=0IUVCJ-e33EQ6uL_nAM&amp;guid=ON&amp;script=0"/> </div> </noscript>